import { call, put, all } from "redux-saga/effects";
import { reportError, reportSuccess } from "../actions/ErrorActions";
import { endLoading, startLoading } from "../actions/LoadingActions";
import { nextSongReviewAPI } from "../api/NextSongReviewCall";
import { noNextReview, retrievedNextReview } from "../actions/NextReviewActions";
import { nextBandPictureApi } from "../api/NextBandPictureReviewCall";

export function* nextReviewSaga(action) { 
    yield put(startLoading());
    var result = yield call(nextSongReviewAPI);
    if (result !== 500 && result.empty) {
        result = yield call(nextBandPictureApi);
    }
    yield put(endLoading());

    try {
        if (result === 500) {
            yield put(reportError("Unable to retrieve next review"));
        } else if (result.empty) {
            yield all([put(noNextReview()), put(reportSuccess("No Reviews Pending"))]);
        } else {
            yield put(retrievedNextReview(result));
        }

    } catch (ex) {
        yield put(reportError("Unable to retrieve next review " + ex));
    }
}